<template>
	<div style="position: relative">
		<div style="display: flex; flex-direction: column; gap: 10px">
			<div style="display: flex; align-items: center; gap: 12px">
				<div>
					<button
						class="panel-close-button"
						@click="$emit('closePanel')"
						title="minimieren"
					>
						<svg-icon type="mdi" :path="mdiChevronRight"></svg-icon>
					</button>
				</div>
				<div>
					<h4>{{ $t("common.panels.messages") }}</h4>
				</div>
			</div>

			<div
				v-if="store.hasOpenValidationMessages"
				style="display: flex; flex-direction: column; gap: 3px"
			>
				<div v-for="(message, index) in openMessages" :key="index">
					<ValidationMessage :message="message"></ValidationMessage>
				</div>
			</div>
			<div v-else>{{ $t("panels.messagePanel.noMessages") }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useMainStore } from "@/store/mainStore";
import { IValidationMessage } from "@/model/IValidationMessage";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiChevronRight } from "@mdi/js";
import { MessageState } from "@/model/Enums";
import ValidationMessage from "./ValidationMessage.vue";

const emit = defineEmits(["closePanel"]);

const store = useMainStore();

const openMessages = computed((): IValidationMessage[] => {
	return store.validationMessages
		? store.validationMessages.filter((m: IValidationMessage) => m.state === MessageState.Open)
		: [];
});
</script>
